import React, { useContext } from "react";
import styled from "styled-components";
import { Form, Formik } from "formik";
import { Trans, useTranslation } from "react-i18next";
import { Button, ButtonToolbar, Col, Row, Input } from "components/bootstrap";
import InputProfileHelpPanel from "./InputProfileHelpPanel";
import { StyledTitle } from "../StyledWizardComponents";
import { ForwarderWizardContext } from "../ForwarderWizardProvider";
import { InputProfilesActions } from "../../stores/InputProfilesStore";
const StyledHelpComponent = styled.div`
  margin-top: 30px;
`;
const InputProfileForm = ({ onCancel, onInputProfileCreated }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { selectedForwarder } = useContext(ForwarderWizardContext);
  if (!selectedForwarder) {
    return /* @__PURE__ */ React.createElement("div", null, t("input_profile_wizard_form.select_forwarder_first"));
  }
  const submitInputProfile = (values, { setSubmitting }) => {
    InputProfilesActions.create(values).then((inputProfile) => {
      setSubmitting(false);
      onInputProfileCreated(inputProfile);
    });
  };
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(StyledTitle, null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "input_profile_wizard_form.heading",
      values: { title: selectedForwarder.title },
      components: { em: /* @__PURE__ */ React.createElement("em", null) }
    }
  )), /* @__PURE__ */ React.createElement(Formik, { initialValues: { title: "", description: "" }, onSubmit: submitInputProfile }, ({ values, handleChange, isSubmitting }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "title",
      name: "title",
      label: t("input_profile_wizard_form.title_label"),
      type: "text",
      value: values.title,
      onChange: handleChange,
      help: t("input_profile_wizard_form.title_help"),
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "description",
      name: "description",
      label: /* @__PURE__ */ React.createElement("span", null, t("input_profile_wizard_form.description_label"), " ", /* @__PURE__ */ React.createElement("small", null, t("input_profile_wizard_form.description_optional"))),
      type: "text",
      value: values.description,
      onChange: handleChange,
      help: t("input_profile_wizard_form.description_help")
    }
  ), /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, t("input_profile_wizard_form.cancel")), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", disabled: isSubmitting }, isSubmitting ? t("input_profile_wizard_form.saving") : t("input_profile_wizard_form.add_inputs")))))), /* @__PURE__ */ React.createElement(Col, { md: 4, mdOffset: 1 }, /* @__PURE__ */ React.createElement(StyledHelpComponent, null, /* @__PURE__ */ React.createElement(InputProfileHelpPanel, null))));
};
export default InputProfileForm;
